export enum UserRole {
  Admin = 'Admin',
  Agent = 'Agent',
  Supervisor = 'Supervisor',
  Limited = 'Limited'
}
